<template>
  <div class="account-tree">
    <div class="tree-content">
      <TreeNode
        v-for="account in accounts"
        :key="account.id"
        :account="account"
        :onAdd="onAdd"
        :onEdit="onEdit"
        :onDelete="onDelete"
      />
    </div>
  </div>
</template>

<script>
import TreeNode from '@/components/TreeNode.vue'

export default {
  name: 'AccountTree',
  components: {
    TreeNode
  },
  props: {
    accounts: {
      type: Array,
      required: true
    },
    onAdd: {
      type: Function,
      required: true
    },
    onEdit: {
      type: Function,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.account-tree {
  width: 100%;
}

.tree-content {
  padding: 20px;
}
</style>
